<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="pb-5 d-flex justify-center">
        <v-dialog
                v-model="isOpen"
                transition="dialog-bottom-transition"
                width="600"
        >
            <div class="main--yellow py-4 d-flex justify-center position-relative">
                <div class="white--text h1 text-uppercase pt-2">
                    {{ $t('orderCreating') }}
                </div>
                <v-btn right absolute class="ml-8" dark icon @click="closeDialog">
                    <v-icon>close</v-icon>
                </v-btn>
            </div>

            <v-card class="d-flex justify-center">
                <v-card width="100%" class="" max-width="880px">
                    <v-card-text class="grey lighten-5 d-flex align-center py-2" width="100%">
                        <span class="title text-uppercase">{{ $t('delivery') }}</span>
                    </v-card-text>
                    <v-divider class="my-4"></v-divider>
                    <v-row class="justify-center" v-if="false">
                        <v-col cols="5">
                            <v-progress-linear
                                    color="orange lighten-2"
                                    indeterminate
                                    rounded
                                    height="3"
                            ></v-progress-linear>
                        </v-col>
                    </v-row>
                    <v-card-text class="py-0">
                        <v-form
                                ref="form"
                                v-model="isValidOrder"
                        >
                            <v-row сlass="pb-4 d-flex flex-wrap grey--text text--lighten-2" cols="12">
                                <v-col cols="12">
                                    <div class="subtitle-2">{{ $t('contactsInfo') }}</div>
                                </v-col>
                                <v-col cols="12" sm="4" class="py-0">
                                    <v-text-field
                                            :label="$t('firstName')"
                                            color="orange lighten-2"
                                            v-model="model.name"
                                            :rules="rules.text"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" class="py-0">
                                    <v-text-field
                                            :label="$t('lastName')"
                                            color="orange lighten-2"
                                            v-model="model.lastName"
                                            :rules="rules.text"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" class="py-0">
                                    <v-text-field
                                            :label="$t('company')"
                                            color="orange lighten-2"
                                            v-model="model.companyName"
                                            :disabled="isUserLoggedIn"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" class="py-0">
                                    <v-text-field
                                            label="E-mail"
                                            color="orange lighten-2"
                                            v-model="model.email"
                                            :rules="rules.email"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" class="py-0">
                                    <v-text-field
                                            :label="$t('telephone')"
                                            color="orange lighten-2"
                                            v-model="model.phone"
                                            :rules="rules.phone"
                                            required
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-divider class="my-2"></v-divider>
                            <v-row сlass="pb-4 d-flex">
                                <v-col cols="12">
                                    <div class="subtitle-2">{{ $t('addressDelivery') }}</div>
                                </v-col>
                                <v-col cols="12" sm="4" class="py-0">
                                    <v-autocomplete
                                            v-model="model.region"
                                            :items="regions"
                                            hide-no-data
                                            item-text="name"
                                            item-value="id"
                                            item-color="orange lighten-2"
                                            :label="$t('region')"
                                            return-object
                                            color="orange lighten-2"
                                            @change="regionChange"
                                            :rules="rules.text"
                                            required
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="4" class="py-0">
                                    <v-autocomplete
                                            v-model="model.geo"
                                            :items="settlements"
                                            hide-no-data
                                            item-text="name"
                                            item-value="id"
                                            item-color="orange lighten-2"
                                            :label="$t('settlement')"
                                            return-object
                                            color="orange lighten-2"
                                            :disabled="!settlements.length"
                                            :loading="settlementsLoad"
                                            :rules="rules.text"
                                            required
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="4" class="py-0">
                                    <v-text-field
                                            :label="$t('address')"
                                            color="orange lighten-2"
                                            v-model="model.address"
                                            :rules="rules.text"
                                            required
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-row>
                                <v-col cols="12">
                                    <div class="subtitle-2">{{ $t('messagesToSeller') }}</div>
                                </v-col>
                                <v-col cols="12" class="py-0">
                                    <v-textarea
                                            color="orange lighten-2"
                                            outlined
                                            v-model="model.message"
                                            :label="$t('messageText')"
                                            :placeholder="`${$t('hello')} ...`"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                    <div class="d-flex justify-center pb-8">
                        <v-btn depressed class="main--yellow white--text mr-4" :disabled="!isValidOrder" @click="send">
                            {{ $t('buy') }}
                        </v-btn>
                        <order-dialog-products></order-dialog-products>
                    </div>
                </v-card>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import GeoService from '../../../../app-front/services/api/GeoService';
    import DataProvider from '../../../../app-front/mixins/OrderDataProvider';
    import OrderDialogProducts from './OrderDialogProducts';
    import Auth from "../../../../app-front/mixins/Auth";


    export default {
        name: "OrderDialog",
        props: ['sellers'],
        mixins: [
            DataProvider,
            Auth
        ],
        components: {
            OrderDialogProducts
        },
        data() {
            return {
                basketData: {},
                e1: 1,
                isValidOrder: false,
                picker: null,
                menu: false,
                dialog: false,
                model: {},
                rules: {
                    email: [
                        v => !!v || this.$t('requiredField'),
                        v => /.+@.+/.test(v) || this.$t('emailInvalid'),
                    ],
                    phone: [
                        v => !!v || this.$t('requiredField'),
                    ],
                    text: [
                        v => !!v || this.$t('requiredField'),
                    ],
                },
                settlements: [],
                settlementsLoad: false,
                snack: false,
                snackColor: null,
                snackText: null,
            }
        },
        computed: {
            dateLabel() {
                let label = 'Выбрать дату';

                if (this.picker) {
                    label += ` (${this.picker})`;
                }

                return label;
            },
            isOpen: {
                get() {
                    return this.$store.state.order.dialog.isOpen;
                },
                set(value) {
                    this.closeDialog();
                }
            },
            orderIds() {
                return this.$store.state.order.products;
            },
            orderProducts() {
                const ids = this.orderIds;

                return this.storeBasketItems.filter(item => ids.indexOf(item.productId) > -1)
            },
            paymentWays() {
                return this.$store.state.baseInfo.paymentWays;
            },
            customerName: {
                get() {
                    const profileData = this.$store.state.account.profileData;

                    if (profileData.firstName && profileData.lastName) {
                        return profileData.firstName.toString() + ' ' + profileData.lastName.toString();
                    } else {
                        return '';
                    }
                },
                set(value) {
                    this.model.name = value
                }
            },
            customerEmail: {
                get() {
                    const profileData = this.$store.state.account.profileData;

                    if (profileData.email) {
                        return profileData.email.toString();
                    } else {
                        return '';
                    }
                },
                set(value) {
                    this.model.email = value
                }
            },
            customerPhone: {
                get() {
                    const profileData = this.$store.state.account.profileData;

                    if (profileData.phone && profileData.phone.clear) {
                        return profileData.phone.clear.toString();
                    } else {
                        return '';
                    }
                },
                set(value) {
                    this.model.email = value
                }
            },
            regions() {
                return this.$store.state.geo.regions;
            },
            storeBasketItems() {
                return this.$store.state.basket.items;
            }
        },
        methods: {
            closeDialog() {
                this.$store.commit('orderDialogUpdate', {isOpen: false});
            },
            regionChange() {
                this.settlementsLoad = true;
                this.settlements = [];
                this.model.geo = null;
                GeoService.setLocale(this.$store.state.language.appLanguage);
                GeoService.getChildrenSettlements(this.model.region.id)
                    .then(res => {
                        this.settlements = res.data;
                        this.settlementsLoad = false;
                    })
                    .catch(err => console.log(err))
            },
            send() {
                if (this.$refs.form.validate()) {
                    this.$emit('create-order', this.model)
                }
            },
            setModel() {
                if (!this.orderBuyerData) return false;

                this.model = this.orderBuyerData;
            },
            updateStore(ids) {
                const basketItems = this.storeBasketItems.filter(item => ids.indexOf(item.productId) < 0);
                const orderIds = this.orderIds.filter(item => ids.indexOf(item) < 0);
                this.$store.commit('setBasket', basketItems);
                this.$store.commit('orderSetProducts', orderIds);
            }
        },
        watch: {
            picker() {
                this.model.deliveryTo = this.picker;
            },
            orderBuyerData: {
                handler() {
                    this.setModel();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
